import { createAction } from '@reduxjs/toolkit';

/* Action dispatched after the list view is paitend in the DOM to handler side effects.
 */
const onListViewPaint = createAction('searchResults/listViewPaint');

export default onListViewPaint;
